import { Button } from '@/components/ui/atoms/button'
import { useStore } from '@nanostores/react'
import { atom } from 'nanostores'
import AccountFormSignIn from './account.form.signin'
import AccountFormSignUp from './account.form.signup'

const formModeAtom = atom<'sign-in' | 'sign-up'>('sign-up')

export default function AccountForm({
  source,
  tokenize,
}: { source?: string; tokenize?: boolean }) {
  const $formMode = useStore(formModeAtom)

  return (
    <div data-div-id="account-form">
      {$formMode === 'sign-up' ? (
        <AccountFormSignUp source={source} tokenize={tokenize} />
      ) : (
        <AccountFormSignIn source={source} tokenize={tokenize} />
      )}
      <p className="text-center text-sm">
        {$formMode === 'sign-up' ? (
          <>
            Já possui acesso?
            <Button
              onClick={() => formModeAtom.set('sign-in')}
              variant="link"
              className="inline p-0 m-0 ml-1 font-semibold"
            >
              Entrar
            </Button>
          </>
        ) : (
          <>
            Ainda não tem acesso?
            <Button
              onClick={() => formModeAtom.set('sign-up')}
              variant="link"
              className="inline p-0 m-0 ml-1 font-semibold"
            >
              Cadastre-se
            </Button>
          </>
        )}
      </p>
    </div>
  )
}
